import './bootstrap';
import 'lazyload';
import slugify from "slugify";
window.slugify = slugify;
window.toastr = require('toastr');
window.moment = require('moment');
import 'daterangepicker';
require('ion-rangeslider/js/ion.rangeSlider.min');

window.user = null;

import './events';
import './common';
import './plugins/badWords';
import './wishlist';
import './preferred-location';
import './plugins/custom-auto-complete';
import Cookies from 'js-cookie';
import jwt_decode from "jwt-decode";
import './auth';
import './auto-complete';

window.jwt_decode = jwt_decode;
window.Cookies = Cookies;

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));


$(function(){
    /* =================== lazy load images ==================== */
    lazyload();
    /* =================== /lazy load images ==================== */


});

